import React from 'react';
import {InstalledBaseNode} from "../../codegen/graphql";
import {Typography} from "@mui/joy";
import {getInstalledBaseTypeIcon} from "@dreebit-registry/vsm-microservice-components";
import Box from "@mui/material/Box";

interface Props {
    node: InstalledBaseNode;
    style?: React.CSSProperties;
    labelType?: "title" | "nodeType" | undefined
}

const NodeLabel = ({node, style, labelType}: Props) => {


    const nodeTypeTitle: (labelType: "title" | "nodeType" | undefined) => string = (type) => {
        switch(type) {
            case "title":
                return node.title
            case "nodeType":
                return node.nodeType.key.toUpperCase()
            default:
                return node.nodeType.key.toUpperCase()
        }
    };


    return <Box style={style} flexDirection={'row'} display="flex" alignItems='center' sx={{gap: '3px', minWidth: 0, overflow: 'hidden'}}>
        <Box sx={{flexShrink: 0, display: 'flex', alignItems: 'center'}}>{getInstalledBaseTypeIcon(node.nodeType.key, 18)}</Box>
        <Typography level={'titleSmall'} component="div" noWrap sx={{flexGrow: 1, minWidth: 0}}>{nodeTypeTitle(labelType)}</Typography>
    </Box>
};

export default NodeLabel;